/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import PropTypes from "prop-types";

export class InputHandle extends Component {
    static get propTypes() {
        return {
            options: PropTypes.string.isRequired,
            updateSearchValues: PropTypes.func.isRequired,
            triggerSearch: PropTypes.func.isRequired
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            searchValue: this.props.options.searchValue
        };
        this.updateInputVal = this.updateInputVal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.generateInput = this.generateInput.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (
            nextProps.options.placeholder
            && this.props.options.placeholder !== nextProps.options.placeholder
        ) {
            this.setState({
                searchValue: ""
            });
        }
    }

    updateInputVal(e) {
        this.props.updateSearchValues(e);
        this.setState({
            searchValue: e
        });
    }

    onChange(e) {
        this.setState({ defaultValue: { value: e.value, label: e.label } });
    }

    generateInput() {
        return (
            <input
                disabled={!this.props.options.searchEnabled}
                required={true}
                type="text"
                className="pe-textInput--basic input-field"
                id="anInput"
                aria-describedby="someHint"
                value={this.props.options.searchValue}
                onChange={e => {
                    this.updateInputVal(e.target.value);
                }}
                placeholder={this.props.options.placeholder}
                onKeyDown={e => {
                    if (e.key === "Enter") {
                        this.props.triggerSearch();
                    }
                }}
            />
        );
    }

    render() {
        return <div className="searchInputBox">{this.generateInput()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/InputHandle.js